import React from 'react';

function SimpleTable({ columns, rows, keyField, noDataIndication, compact = false }) {
  const tableClass = compact ? "w-full table-fixed border-collapse text-left text-sm" : "w-full min-w-[760px] border-collapse text-left text-sm";
  const cellClass = compact ? "px-3 py-4 align-middle break-words" : "px-4 py-4 align-middle";

  return (
    <div className={compact ? "overflow-hidden rounded-xl border border-slate-200 bg-white" : "overflow-x-auto rounded-xl border border-slate-200 bg-white"}>
      <table className={tableClass}>
        <thead className="bg-[#f6f8fc] text-[11px] font-black uppercase tracking-wide text-[#171d54]">
          <tr>
            {columns.map((column) => (
              <th key={column.dataField} className="border-b border-slate-200 px-3 py-3 break-words">{column.text}</th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows && rows.length ? rows.map((row, index) => (
            <tr key={`${row[keyField] || 'row'}-${index}`} className="bg-white text-slate-600 odd:bg-white even:bg-slate-50/50">
              {columns.map((column) => (
                <td key={`${row[keyField] || 'row'}-${index}-${column.dataField}`} className={cellClass}>
                  {column.render ? column.render(row) : row[column.dataField]}
                </td>
              ))}
            </tr>
          )) : (
            <tr>
              <td colSpan={columns.length} className="px-4 py-8 text-center text-sm font-bold text-slate-500">{noDataIndication}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SimpleTable;
